// dependencies
import React, { useState, useCallback } from "react";
import { useIntl } from "react-intl";

// components
import Button from "@cloudspire/legacy-resources/src/components/Button2";

// libraries
import { noop } from "@cloudspire/legacy-shared/src/libraries";

type PropsType = {
  phone: string;
  onPress?;
};

const SpoilerOwnerPhoneButton: React.FunctionComponent<PropsType> = (props) => {
  const { phone, onPress = noop, ...otherProps } = props;

  const intl = useIntl();

  const [spoiled, setSpoiled] = useState(false);

  const handlePress = useCallback(
    (event) => {
      event.persist();

      setSpoiled(true);

      onPress(event);
    },
    [onPress]
  );

  return (
    <Button
      {...otherProps}
      appearance="primary"
      {...(spoiled && { to: `tel:${phone}` })}
      label={
        spoiled
          ? phone
          : intl.formatMessage({
              defaultMessage: "Appeler le propriétaire",
            })
      }
      onPress={handlePress}
    />
  );
};

export default SpoilerOwnerPhoneButton;
